import { Search } from 'components/icons/Search'
import type { ForwardedRef } from 'react'
import { forwardRef, useCallback } from 'react'
import type { BreakoutInputProps } from './BreakoutTextInput'
import { BreakoutTextInput } from './BreakoutTextInput'
import classNames from 'classnames'

// A convenience component for the BreakoutTextInput that is preconfigured for search input
export const BreakoutSearchInput = forwardRef(function BreakoutSearchInput(
  {
    size = 'default',
    ...rest
  }: Omit<BreakoutInputProps, 'LeadingIcon' | 'size'> & {
    size?: 'default' | 'small'
  },
  ref: ForwardedRef<HTMLInputElement>
) {
  const iconFunc = useCallback(
    ({ size, className }: { size: number; className?: string }) => {
      return <Search size={size} className={className} />
    },
    []
  )

  return (
    <BreakoutTextInput
      {...rest}
      inputClassName={classNames(
        'text-body-medium! outline-outline-light',
        size === 'small' && 'h-10!',
        rest.inputClassName
      )}
      iconClassName={classNames(
        'left-4!',
        'stroke-on-surface-var',
        rest.iconClassName
      )}
      kind={rest.kind ?? 'tertiary'}
      LeadingIcon={iconFunc}
      ref={ref}
      iconSize={rest.iconSize ?? 15}
      allowClear={rest.allowClear ?? true}
    />
  )
})
